'use client';

import { HTMLProps, ReactNode } from 'react';

import dynamic from 'next/dynamic';
import { LinkProps } from 'next/link';

import useWebAlias from '@/helpers/hooks/useWebalias';

const Link = dynamic(() => import('next/link'));

type WebaliasLinkProps = {
  href: string;
  children: ReactNode;
} & (
  | ({
      as?: 'Link';
    } & Omit<LinkProps, 'href' | 'ref'>)
  | ({
      as?: 'a';
    } & Omit<HTMLProps<HTMLAnchorElement>, 'href' | 'ref'>)
);

export default function WebaliasLink({ href, children, as, ...restProps }: WebaliasLinkProps) {
  const { webalias } = useWebAlias();
  if (as === 'a')
    return (
      <a href={href.replace('{0}', webalias)} {...restProps}>
        {children}
      </a>
    );
  return (
    <Link href={href.replace('{0}', webalias)} {...restProps}>
      {children}
    </Link>
  );
}
